/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Missing_AltInputs */

const vi_media_missing_alt = /** @type {(inputs: Media_Missing_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiếu mô tả`)
};

/**

* @param {Media_Missing_AltInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_missing_alt = /** @type {((inputs?: Media_Missing_AltInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Missing_AltInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_missing_alt(inputs)
});